export default "__VITE_ASSET__BMnBoHwX__"